const OPTIONAL_LEGACY_TEMPLATE_TABLE = /Table\s+'[^']*\.lzg_template_(?:type|info)'\s+doesn't exist/i;

export function isOptionalLegacyTemplateSourceUnavailable(payload) {
  if (payload?.available !== false) return false;
  return OPTIONAL_LEGACY_TEMPLATE_TABLE.test(String(payload?.message || ""));
}

export function normalizeTemplateSourceCatalog(payload = {}) {
  if (!isOptionalLegacyTemplateSourceUnavailable(payload)) return payload;
  return {
    ...payload,
    available: true,
    stale: false,
    message: "",
  };
}

export function createSingleFlight() {
  const inFlight = new Map();

  return function runSingleFlight(key, task) {
    const normalizedKey = String(key || "").trim();
    if (!normalizedKey) return Promise.resolve().then(task);
    if (inFlight.has(normalizedKey)) return inFlight.get(normalizedKey);

    let running;
    running = Promise.resolve()
      .then(task)
      .finally(() => {
        if (inFlight.get(normalizedKey) === running) inFlight.delete(normalizedKey);
      });
    inFlight.set(normalizedKey, running);
    return running;
  };
}
